import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Coverage } from '@amfam/policy/models';

interface PolicyCoverages {
  coverages: CoveragesModel[];
  additionalCoverages: string[];
}
interface CoveragesModel {
  isImpliedCoverage: boolean;
  isLiabilityCoverage: boolean;
  isStandardCoverage: boolean;
  isVisible: boolean;
  subHeading: string;
  coverage: Coverage;
}

@Component({
  selector: 'ds-included-coverages',
  templateUrl: './included-coverages.component.html',
  styleUrls: ['./included-coverages.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class IncludedCoveragesComponent {
  @Input() coverages: PolicyCoverages;
  @Input() sectionHeader: string;
}
